import React from 'react'
import "../componentcss/Rightbar.css";
export default function Rightbar() {
  return (
    <div className="RightSide">
    <div className="right1">
      <img src="https://cdn.testbook.com/products/2023/February/7/__w-200-400-600__/Getting%20Started%20with%20Agile%20Methodology.png.png " alt=""/>
    </div>
    <div className="right2">
    <img src=" https://cdn.testbook.com/products/2023/February/7/__w-200-400-600__/Getting%20Started%20with%20Agile%20Methodology.png.png" alt=""/>
    </div>
    </div>
  )
}

 
